// react context providing profile information
import React, { createContext, useContext } from 'react';

import { AuthUserContext } from '../components/auth-component';
import { useIndex } from '../hooks';

export const ProfileContext = createContext(null);

export function ProfileProvider({ children }) {
  const { user } = useContext(AuthUserContext);
  const { loading, data: profiles, update } = useIndex('profiles', { user_id: user?.id });
  const profile = profiles ? profiles[0] : null;

  if (loading) {
    return <div>Loading profile...</div>;
  }

  // if (!loading && !profile) {
  //   return <div>Error, no profile found. Try refreshing the page.</div>;
  // }

  return <ProfileContext.Provider value={{ profile, update }}>{children}</ProfileContext.Provider>;
}
